/**
 * Regole pure del popup «Invita» (spec 2026-10-15, parte B), condiviso dal
 * Composer (voce in coda all'elenco @) e dalla card Proprietà.
 */
import type { InviteCandidate, Mentionable } from '../../services/supportApi';

/** Minimo di caratteri prima di cercare e attesa dopo l'ultima battuta. */
export const INVITE_MIN_CHARS = 2;
export const INVITE_DEBOUNCE_MS = 300;

const keyOf = (c: { actorType: string; actorId: string }) => `${c.actorType}:${c.actorId}`;

export const inviteDisplayName = (c: InviteCandidate): string => `${c.nome} ${c.cognome || ''}`.trim();

/** Seconda riga: «Carica · Studio · PR», solo i dati presenti. */
export const inviteRowMeta = (c: InviteCandidate): string =>
  [c.carica, c.studio, c.provincia].filter(Boolean).join(' · ');

/** Pagina successiva accodata: chi c'è già non si ripete. */
export const mergeInvitePages = (prev: InviteCandidate[], next: InviteCandidate[]): InviteCandidate[] => {
  const seen = new Set(prev.map(keyOf));
  return [...prev, ...next.filter((c) => !seen.has(keyOf(c)))];
};

/** Invitato scelto dal Composer: entra nel testo come menzione (`ruolo: 'invitato'`). */
export const inviteToMentionable = (c: InviteCandidate): Mentionable => ({
  actorType: c.actorType,
  actorId: c.actorId,
  nome: inviteDisplayName(c),
  ...(c.foto ? { foto: c.foto } : {}),
  ruolo: 'invitato',
});
